import React from 'react'
import { MenuItem, Select, Typography, theme } from 'cdh-data-portal-theme'
import type { useStyles } from '../DataGovernorsPage.style'
import { ENVIRONMENT_OPTIONS, ENVIRONMENT_TABS, localText } from '../DataGovernorsPage.static'
import type { EnvironmentTab } from '../DataGovernorsPage.static'
export interface EnvironmentTabsRowProps {
  readonly classes: ReturnType<typeof useStyles>['classes']
  readonly activeTab: EnvironmentTab
  readonly intEnvironment: string
  readonly onSelectTab: (tabIndex: number) => void
  readonly onIntEnvironmentChange: (environment: string) => void
}

export const EnvironmentTabsRow: React.FC<EnvironmentTabsRowProps> = ({
  classes,
  activeTab,
  intEnvironment,
  onSelectTab,
  onIntEnvironmentChange,
}) => (
  <div className={classes.tabsRow}>
    <div role="tablist" className={classes.tabButtonGroup}>
      {ENVIRONMENT_TABS.map((option, index) => {
        const isSelected = option.tab === activeTab
        return (
          <button
            key={option.tab}
            type="button"
            role="tab"
            aria-selected={isSelected}
            className={isSelected ? `${classes.tabButton} ${classes.tabButtonSelected}` : classes.tabButton}
            onClick={() => onSelectTab(index)}
          >
            <Typography variant="headline2" color={isSelected ? 'white' : theme.textColors.primary}>
              {option.title}
            </Typography>
          </button>
        )
      })}
    </div>
    {activeTab === 'int' && (
      <Select
        className={classes.environmentInline}
        label={localText.environmentLabel}
        onChange={(event) => onIntEnvironmentChange(event.target.value)}
        value={intEnvironment}
        variant="small"
      >
        {ENVIRONMENT_OPTIONS.map((option) => (
          <MenuItem key={option.value} selectable value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    )}
  </div>
)
